import { useTranslation } from "react-i18next";
import { ModuleTabs } from "../../components/data/ModuleTabs";
import { TABS } from "./acctTabs";

const TONES = ["sky", "emerald", "amber", "violet", "teal", "rose", "indigo", "lime",
               "orange", "cyan"];

// تبويبات قسم المحاسبة — نفس نظام الشرائح الملوّنة الموحّد.
export const AcctNav = () => {
  const { t } = useTranslation();
  return (
    <ModuleTabs
      testid="acct-nav"
      wrap
      tabs={TABS.map((tab, index) => ({ ...tab, tone: TONES[index % TONES.length],
                                        label: t(`acct.tabs.${tab.key}`) }))}
    />
  );
};
